import { forwardRef } from 'react'
import { useTranslation } from '@front/model'
import { createPolymorphicComponent } from '@mantine/core'
import { TButton, type TButtonProps } from './button'

export type ButtonAddProps = Omit<TButtonProps, 'leftSection' | 'icon'>

const _ButtonAdd = forwardRef<HTMLButtonElement, ButtonAddProps>(({ children, ...props }, ref) => {
  const { t } = useTranslation()
  return (
    <TButton icon='add' {...props} ref={ref}>
      {children || t('Add')}
    </TButton>
  )
})

_ButtonAdd.displayName = 'ButtonAdd'

export const ButtonAdd = createPolymorphicComponent<'button', ButtonAddProps>(_ButtonAdd)
